import { useState } from "react";
import { useIsMobile } from "./useIsMobile";
import { useAppContext } from "@context/app";

const useScroll = () => {
  const [isScrollBlocked, setScrollBlocked] = useState(false);
  const isMobile = useIsMobile(780);

  const blockScroll = () => {
    if (typeof document === "undefined" || isScrollBlocked) return;
    const html = document.documentElement;
    const body = document.body;
    if (!body || !body.style) return;

    const scrollBarWidth = window.innerWidth - html.clientWidth;
    const bodyPaddingRight =
      parseInt(
        window.getComputedStyle(body).getPropertyValue("padding-right")
      ) || 0;

    html.style.position = "relative";
    html.style.overflow = "hidden";
    body.style.position = "relative";
    if (isMobile) body.style.overflow = "hidden";
    body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

    setScrollBlocked(true);
  };

  const allowScroll = () => {
    if (typeof document === "undefined" || !isScrollBlocked) return;
    const html = document.documentElement;
    const body = document.body;
    if (!body || !body.style) return;

    html.style.position = "";
    html.style.overflow = "";
    body.style.position = "";
    body.style.overflow = "";
    body.style.paddingRight = "";

    setScrollBlocked(false);
  };

  return { blockScroll, allowScroll };
};

export default useScroll;
